// 纯内存 session store，不会持久化到 localStorage。
// CSRF token 也放在这里（design.md §5.3）：页面刷新后它会丢失，
// 壳层必须重新调用 /auth/session 来恢复状态。
import { create } from 'zustand';

export interface SessionUser {
  id: number;
  username: string;
  display_name: string;
  email: string | null;
  avatar_url: string | null;
  locale: string;
  must_change_password: boolean;
}

export type SessionStatus = 'unknown' | 'anonymous' | 'authenticated';

export interface SessionState {
  status: SessionStatus;
  user: SessionUser | null;
  csrfToken: string | null;
  bootstrapError: string | null;
  setAuthenticated: (user: SessionUser, csrfToken: string) => void;
  setAnonymous: () => void;
  setBootstrapError: (message: string) => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  status: 'unknown',
  user: null,
  csrfToken: null,
  bootstrapError: null,
  setAuthenticated: (user, csrfToken) =>
    set({ status: 'authenticated', user, csrfToken, bootstrapError: null }),
  setAnonymous: () => set({ status: 'anonymous', user: null, csrfToken: null, bootstrapError: null }),
  setBootstrapError: (message) =>
    set({ status: 'unknown', bootstrapError: message, user: null, csrfToken: null }),
  clear: () => set({ status: 'unknown', user: null, csrfToken: null, bootstrapError: null }),
}));
